import React, { useEffect } from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { Div, MediumOutlineButton } from "components/Base";
import css from "../styles.scss";
import Loading from "ui-kit/Loading";
import { connect } from "react-redux";
import { noop } from "utils/General";
import { actions, getters } from "../model";
import Field from "./Field";
import {
  getValues,
  getFields,
  getTranslatedValuesForField
} from "../selectors";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { CUSTOM_FIELDS_DETAILS_FORM_ID } from "../constants";

import CollapsableWrapper from "EventLight/Sessions/Page/View/CollapsableWrapper";
import { LanguageVariantModal } from "../../View/LanguageVariantUI";

const mapIndexed = R.addIndex(R.map);

const decorate = R.compose(
  WithFormInstanceProvider(R.always(CUSTOM_FIELDS_DETAILS_FORM_ID)),
  connect(
    (state, props) => ({
      isLoading: getters.loading(state),
      fields: getFields(state),
      values: getValues(state),
      editingFieldId: getters.editingFieldId(state, props),
      languageModalIsOpen: getters.languageModalIsOpen(state),
      selectedTranslatedFieldId: getters.selectedTranslatedFieldId(state),
      translatedValues: getTranslatedValuesForField(state)
    }),
    {
      init: actions.init,
      showSelectFieldsModal: actions.showSelectFieldsModal,
      onEdit: actions.onEdit,
      setEditingFieldId: actions.setEditingFieldId,
      setSelectedTranslatedFieldId: actions.setSelectedTranslatedFieldId,
      toggleLanguageModal: value => actions.setLanguageModalIsOpen(value),
      updateTranslatedValue: actions.updateTranslatedValue,
      saveLanguageValues: actions.saveLanguageValues
    }
  ),
  CSSModules(css)
);

const CustomFields = ({
  isLoading = true,
  sessionId,
  sessionRecordId,
  init = noop,
  showSelectFieldsModal = noop,
  fields = [],
  values = {},
  onEdit = noop,
  editingFieldId = null,
  setEditingFieldId = noop,
  disabled = false,
  languageModalIsOpen,
  setSelectedTranslatedFieldId,
  toggleLanguageModal,
  translatedValues,
  updateTranslatedValue,
  saveLanguageValues
}) => {
  useEffect(() => {
    init({ sessionId, sessionRecordId });
  }, []);
  if (R.length(fields) === 0 && isLoading) {
    return null;
  }
  return (
    <>
      <CollapsableWrapper
        title="Custom Fields"
        headingLeftComp={
          <MediumOutlineButton
            width={150}
            color="info8"
            bc="info8"
            onClick={e => {
              e.stopPropagation();
              showSelectFieldsModal();
            }}
          >
            Show/Hide Fields
          </MediumOutlineButton>
        }
      >
        {!isLoading && R.length(fields) > 0 && (
          <Div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <Div pt={2}>
              <ul className={css.customFieldsContainer}>
                {mapIndexed((record, index) => (
                  <Field
                    field={record}
                    values={values}
                    onEdit={onEdit}
                    editingFieldId={editingFieldId}
                    index={index}
                    disabled={disabled}
                    setEditingFieldId={setEditingFieldId}
                    toggleLanguageModal={toggleLanguageModal}
                    setSelectedTranslatedFieldId={setSelectedTranslatedFieldId}
                  />
                ))(fields)}
              </ul>
            </Div>
          </Div>
        )}
        {isLoading && <Loading />}
      </CollapsableWrapper>

      {languageModalIsOpen ? (
        <LanguageVariantModal
          translatedValues={translatedValues}
          languageModalIsOpen={languageModalIsOpen}
          updateTranslatedValue={updateTranslatedValue}
          toggleLanguageModal={toggleLanguageModal}
          saveButtonLabel="Save"
          onSave={() => {
            saveLanguageValues();
            toggleLanguageModal();
          }}
        />
      ) : null}
    </>
  );
};

export default decorate(CustomFields);
